/**
 * 模块名称: 内部结算配置
 * @author zhuyan@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import SettleConfig from './SettleConfig'

const SettleConfigIndex = ({ match, history }) => {

  return (
    <div>
      <Switch>
        <Route path={match.path + '/settleConfig'} component={SettleConfig} />
        <Route component={SettleConfig} />
      </Switch>
    </div>
  )
}

export default SettleConfigIndex